// @ts-expect-error - Automatic, Please fix when editing this file
const toasts = [];

// @ts-expect-error - Automatic, Please fix when editing this file
export default toasts;
